// extracted by mini-css-extract-plugin
export default {"orders_toolip":"orders_toolip___s9uyp"};